<template>
    <div class="module-related-list">
        <div class="module-related-list__container">
            <div class="module-related-list__menu" v-if="modules.length > 0">
                <div
                    v-for="module in modules"
                    :key="module.id"
                    @click="selectedModule = module"
                    class="module-related-list__menu-item"
                    :class="{ selected: $_.get(selectedModule, 'moduleName') === module.moduleName }"
                >
                    <i class="material-icons">{{ module.icon || "list" }}</i>
                    <span>{{ module.displayName }}</span>
                </div>
            </div>

            <div
                class="module-related-list__content"
                v-if="modules.length > 0"
                :key="$_.get(selectedModule, 'moduleName')"
            >
                <div class="module-related-list__content-inner" v-if="selectedModule">
                    <TableDetail
                        :defaultRecords="records"
                        :moduleMode="true"
                        :defaultTableId="selectedModule.relation.tableToTable.to.table"
                        :predefinedValues="getTablePredefinedValues()"
                        @record-created="onRecordCreated"
                        :default-linked-record-cache="getLinkedRecordCache()"
                        :implicit-filters="getImplicitFilters()"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { MODULE_API } from "../../../../api/module";
import TableDetail from "./TableDetail.vue";

export default {
    name: "ModuleRelatedList",
    components: {
        TableDetail,
    },
    data() {
        return {
            selectedModule: null,
            records: [],
            loading: false,
            modules: [],
        };
    },
    props: {
        tableId: {
            type: String,
            required: true,
        },
        recordId: {
            type: String,
            required: true,
        },
        record: {
            type: Object,
        },
    },
    computed: {
        ...mapGetters("module", ["getTableRelatedModules"]),
    },
    methods: {
        getLinkedRecordCache() {
            return {
                [this.recordId]: this.record,
            };
        },
        redirectToTables() {
            this.$router.push("/tables");
        },
        fetchRelatedModuleRecords() {
            if (!this.selectedModule) return;
            return MODULE_API.getModuleRelatedList(this.selectedModule.moduleName, this.tableId, this.recordId)
                .then((result) => {
                    this.records = result.items;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getImplicitFilters() {
            const module = this.selectedModule;
            if (!module || !module.relation) return [];

            const filters = [];
            if (module.relation.type === "table-to-table") {
                const toConnection = module.relation.tableToTable.to;
                const fromConnection = module.relation.tableToTable.from;

                if (toConnection.connectionType === "field") {
                    filters.push({
                        operator: "equal",
                        fieldId: toConnection.field,
                        value: this.$_.get(this.record, "data." + fromConnection.field),
                    });
                } else if (toConnection.connectionType === "_id") {
                    filters.push({
                        operator: "equal",
                        fieldId: "_id",
                        value: this.recordId,
                    });
                }
            }
            console.log("implicit filters", filters);

            return filters;
        },

        getTablePredefinedValues() {
            const module = this.selectedModule;
            if (!module || !module.relation) return {};

            let filterFieldId;
            let filterValue;

            if (module.relation.type === "table-to-table") {
                const toConnection = module.relation.tableToTable.to;
                const fromConnection = module.relation.tableToTable.from;

                // Karşı tabloda (_id ile filtreleme yapılacaksa boş bırak)
                filterFieldId = toConnection.connectionType === "field" ? toConnection.field : null;

                // From değerini mevcut kayıttan al
                filterValue =
                    fromConnection.connectionType === "_id"
                        ? this.recordId
                        : this.$_.get(this.record, "data." + fromConnection.field);
            }

            // Eğer filterFieldId null ise, bu _id ile filtreleme yapılacak demektir
            // Bu durumda predefined values boş dönmeli çünkü TableDetail komponenti
            // defaultRecords üzerinden zaten filtrelenmiş verileri alacak
            if (!filterFieldId) {
                return {};
            }

            return {
                [filterFieldId]: filterValue,
            };
        },
        onRecordCreated(newRecord) {
            this.fetchRelatedModuleRecords();
        },
    },
    created() {
        this.modules = this.getTableRelatedModules(this.tableId);
        this.selectedModule = this.modules[0];
    },
    watch: {
        selectedModule: {
            handler(newVal) {
                this.records = [];
                this.fetchRelatedModuleRecords();
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.module-related-list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    &__container {
        display: flex;
        height: 100%;
    }

    &__menu {
        flex: 0 0 200px;
        border-right: 1px solid #e8e8e8;
        height: 100%;

        &-item {
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            padding: 8px;
            border-radius: 4px;
            font-size: 14px;
            color: #333;

            &:hover {
                background-color: #f0f0f0;
            }

            &.selected {
                background-color: #e8e8e8;
            }
        }
    }

    &__create-button {
        margin-bottom: 16px;
    }

    &__content {
        flex: 1;
        height: 100%;
        width: 100%;
        overflow: hidden;

        &-inner {
        }

        .table-body {
            width: 100%;
            overflow: scroll;
        }
    }
}
</style>
